import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
//import { Ng4LoadingSpinnerModule, Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AccountInfo, AuthenticationResult, InteractionStatus } from '@azure/msal-browser';
import { filter } from 'rxjs/operators';
import { NgxSpinnerService } from "ngx-spinner";
import { CompareService } from '../compare/compare.service';
import { IWorkItem } from '../shared/workItem';
import { IProject } from '../shared/project';
import { IRepo } from '../shared/repo';
import { IBuild } from '../shared/build';
import { ICompareFormObj } from '../shared/compareFormObj';
import * as auth from '../auth-config.json';
import { Account } from '../shared/account';

@Component({
  selector: 'app-compare',
  templateUrl: 'compare.component.html',
  styleUrls: ['compare.component.css']
})
export class CompareComponent implements OnInit {

  constructor(private data: CompareService, private spinner: NgxSpinnerService, private router: Router,
      private fb: FormBuilder, private authService: MsalService, private msalBroadcastService: MsalBroadcastService) {
  }
  public compareForm: FormGroup;
  public projects: IProject[];
  public workitems: IWorkItem[];
  public repos: IRepo[];
  public builds: IBuild[];
  public selectedProject: string;
  public selectedRepo: string;
  public buildStart: number;
  public buildEnd: number;
  public branchType: string = "release";
  public compareFormObjects: ICompareFormObj[] = new Array();
  loginDisplay = false;
  public message: string = "You must login to view this page.";

  ngOnInit() {

    this.handleSecurity();

    this.loadProjectDropdown();

    this.compareForm = this.fb.group({
      ddlStart: [''],
      ddlEnd: ['']
    })
  }

  handleSecurity() {

    this.authService.handleRedirectObservable().subscribe({
      next: (result: AuthenticationResult) => {
        if (result) {
          this.authService.instance.setActiveAccount(result.account);
          console.log(result);
        }
        // Sets login display when using redirects
        this.setLoginDisplay();
      },
      error: (error) => console.log(error)
    });

    // Sets login display when using popups
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None)
      )
      .subscribe(() => {
        this.setLoginDisplay();
      });
  }

  setLoginDisplay() {
    let allowedRoles = [auth.roles.BuildManager];

    let accounts: AccountInfo[] = this.authService.instance.getAllAccounts();
    let account: Account = accounts[0];

    this.loginDisplay = accounts.length > 0;

    if (this.loginDisplay && !allowedRoles.includes(account.idTokenClaims?.roles[0])) {
      this.loginDisplay = false;
      this.message = 'You do not have the correct permissions to view this page.';
    }
  }

  loadProjectDropdown() {
    this.data.loadProjects()
      .subscribe(data => {
        this.projects = data;
      });
  }

  resetValues() {
    this.repos = null;
    this.selectedRepo = "";
    this.buildStart = null;
    this.buildEnd = null;
    this.builds = null;
  }

  cancel() {
    this.resetValues();
    if (this.selectedProject !== "") {
      this.selectedProject = "";
      this.projects = null;
      this.loadProjectDropdown();
    }
    //this.router.navigate(['/compare'])
  }

  getRepos(name: any) {
    if (name !== "0") {
      this.resetValues();
      this.selectedProject = name;
      this.data.getReposByProject(name)
        .subscribe(data => {
            this.repos = data;
        });
    } 
  }

  setBranchType(typeName: string) {
    this.branchType = typeName;
  }

  getBuilds(repo: string) {
    if (repo !== "0") {
      this.selectedRepo = repo;
      this.buildStart = null;
      this.buildEnd = null;
      this.builds = null;
      this.data.getBuildsByRepo(this.selectedProject, repo, this.branchType)
        .subscribe(data => {
            this.builds = data;
        });
    } 
  }

  removeCompare(startId: string) {
    this.compareFormObjects = this.compareFormObjects.filter((obj) => {
      return obj.startBuildId !== parseInt(startId);
    });
  }

  containsObject(obj: ICompareFormObj, ary: ICompareFormObj[]) {

    for (let i = 0; i < ary.length; i++) {
      if (ary[i].repositoryId === obj.repositoryId
        && ary[i].startBuildId === obj.startBuildId
        && ary[i].endBuildId === obj.endBuildId)
        return true;
    }
    return false;
  }

  addCompareFormObject() {

    const repo = this.repos.find(r => r.id === this.selectedRepo);
    const buildS = this.builds.find(b => b.id === this.buildStart);
    const buildE = this.builds.find(b => b.id === this.buildEnd);

    const compare: ICompareFormObj =
    {
      branchType: this.branchType,
      projectName: this.selectedProject,
      repositoryId: this.selectedRepo,
      startBuildId: this.buildStart,
      endBuildId: this.buildEnd,
      repoName: repo.name,
      startBuildDisplay: buildS.buildNumber + ', ' + buildS.sourceBranch,
      endBuildDisplay: buildE.buildNumber + ', ' + buildE.sourceBranch
    };

    if (!this.containsObject(compare, this.compareFormObjects))
      this.compareFormObjects.push(compare);
  }

  setStartBuild(build: string) {
    this.buildStart = parseInt(build);
  }

  setEndBuild(build: string) {
    this.buildEnd = parseInt(build);
  }

  getWorkItemsFromForm() {//formValues) {
    //this.buildStart = formValues.ddlStart;
    //this.buildEnd = formValues.ddlEnd;
    this.getWorkItems();
  }

  getWorkItems() {

   // this.spinnerService.show();
    this.spinner.show();

    //how do we handle DB work items? We want to know if they were DB or not.

    if (this.compareFormObjects !== null) {

      this.data.getWorkItemsBetweenBuildsBatch(this.compareFormObjects)
        .subscribe(data => {
          this.workitems = data;
         // this.spinnerService.hide();
          this.spinner.hide();
        });
    }

    //if (this.selectedProject != "0") {

    //  if (this.buildEnd != "0") {
    //    this.data.getWorkItemsBetweenBuilds(this.selectedProject, this.buildStart, this.buildEnd)
    //      .subscribe(data => {
    //        this.workitems = data;
    //        this.spinnerService.hide();
    //      });
    //  }
    //  else {
    //    this.data.getWorkItemsByBuild(this.selectedProject, this.buildStart)
    //      .subscribe(data => {
    //        this.workitems = data;
    //        this.spinnerService.hide();
    //      });
    //  }
    //}
  }

  refreshGrid(arg: any) {
    this.getWorkItems();
  }

}
